import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { receiptShellRoutes } from '@kempower-nx-workspace/receipt-lookup-app-shell';
import { AuthTokenServiceModule as AuthTokenServiceModuleOyj } from '@kempoweroyj/ngx-auth-token-service';
import { AuthTokenServiceModule } from '@kempowersw/ngx-auth-token-service';
import { ConfigService } from '@kempower-nx-workspace/receipt-lookup-environment';
import { BrandingApiServiceObservable } from '@kempoweroyj/ngx-branding-api-client';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CaptchaService } from '@kempower-nx-workspace/receipt-lookup-page';

function initializeCaptcha(captchaService: CaptchaService) {
    return () => captchaService.loadCaptchaScript();
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(receiptShellRoutes),
        provideHttpClient(),
        ConfigService,
        AuthTokenServiceModule,
        AuthTokenServiceModuleOyj,
        provideAnimations(),
        BrandingApiServiceObservable,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeCaptcha,
            deps: [CaptchaService],
            multi: true,
        },
    ],
};
